var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.627,
    height: 23.141,
    viewBox: "0 0 17.627 23.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs_1_",
    "data-name": "google-docs (1)",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs_3_",
    transform: "translate(61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35611",
    "data-name": "Group 35611",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35610",
    "data-name": "Group 35610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35609",
    "data-name": "Group 35609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35608",
    "data-name": "Group 35608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72803",
    "data-name": "Path 72803",
    d: "M78.627,6.1,73.881,4.746,72.525,0H63.034A2.034,2.034,0,0,0,61,2.034V21.107a2.034,2.034,0,0,0,2.034,2.034H76.593a2.034,2.034,0,0,0,2.034-2.034Z",
    transform: "translate(-61)",
    fill: "#4086f4"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72805",
    "data-name": "Path 72805",
    d: "M322.1,6.1h-4.746A1.36,1.36,0,0,1,316,4.746V0a.636.636,0,0,1,.475.2L321.9,5.627A.636.636,0,0,1,322.1,6.1Z",
    transform: "translate(-304.475)",
    fill: "#80aef8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35612",
    "data-name": "Group 35612",
    transform: "translate(4.068 9.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72806",
    "data-name": "Path 72806",
    d: "M159.813,212.356h-8.136a.678.678,0,1,1,0-1.356h8.136a.678.678,0,1,1,0,1.356Z",
    transform: "translate(-151 -211)",
    fill: "#fff5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35613",
    "data-name": "Group 35613",
    transform: "translate(4.068 12.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72807",
    "data-name": "Path 72807",
    d: "M159.813,272.356h-8.136a.678.678,0,1,1,0-1.356h8.136a.678.678,0,1,1,0,1.356Z",
    transform: "translate(-151 -271)",
    fill: "#fff5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35614",
    "data-name": "Group 35614",
    transform: "translate(4.068 14.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72808",
    "data-name": "Path 72808",
    d: "M159.813,332.356h-8.136a.678.678,0,1,1,0-1.356h8.136a.678.678,0,1,1,0,1.356Z",
    transform: "translate(-151 -331)",
    fill: "#fff5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35615",
    "data-name": "Group 35615",
    transform: "translate(4.068 17.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72809",
    "data-name": "Path 72809",
    d: "M157.1,392.356h-5.424a.678.678,0,1,1,0-1.356H157.1a.678.678,0,1,1,0,1.356Z",
    transform: "translate(-151 -391)",
    fill: "#fff5f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4a2e434131fb639f9d65e343510d5b9a.svg";
export { ForwardRef as ReactComponent };